// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: #ffffff;
}

.home-page__body {
  flex: 1;
  overflow: auto;
  padding: 16px;
}

@media (min-width: 768px) {
  .home-page__body {
    /* Stitch: p-6 on content area */
    padding: 24px;
  }
}

.home-page__finder {
  display: flex;
  margin-bottom: 16px;
}

.home-doctor-finder {
  width: min(320px, 100%);
  margin-inline-start: auto;
}

.home-doctor-finder.ant-select .ant-select-selector {
  height: 36px !important;
  border-radius: 8px !important;
  border-color: #e2e8f0 !important;
  background: #f8fafc !important;
  align-items: center;
}

.home-page__columns {
  --home-columns: 1;
  display: grid;
  grid-template-columns: repeat(var(--home-columns), minmax(0, 1fr));
  gap: 24px;
  align-items: start;
  width: 100%;
  max-width: calc(var(--home-columns) * 480px + (var(--home-columns) - 1) * 24px);
}

.home-page__column {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  max-width: 100%;
  width: 100%;
  overflow: hidden;
}

.home-queue {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  max-width: 100%;
  width: 100%;
}

.home-queue__loader {
  min-width: 0;
  max-width: 100%;
  width: 100%;
}

.home-doctor-head__name {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home-doctor-head__specialty {
  margin: 2px 0 0;
  font-size: 13px;
  font-weight: 400;
  color: #64748B;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home-queue-search.ant-input-affix-wrapper {
  width: 100% !important;
  height: 36px !important;
  border-radius: 8px !important;
  background: #F8FAFC !important;
  border-color: #E2E8F0 !important;
}

.home-queue-search.ant-input-affix-wrapper-focused {
  border-color: #0EA5E9 !important;
  background: #ffffff !important;
  box-shadow: 0 0 0 1px #0EA5E9 !important;
}

.home-queue-search .ant-input {
  background: transparent !important;
  font-size: 13px !important;
}

.home-queue-empty {
  padding: 20px 16px;
  border-radius: 8px;
  border: 1px dashed #CBD5E1;
  background: #F8FAFC;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #94A3B8;
  width: 100%;
  box-sizing: border-box;
}

.home-queue-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.home-queue-list > * {
  min-width: 0;
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,cAAc;EACd,aAAa;AACf;;AAEA;EACE;IACE,gCAAgC;IAChC,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".home-page {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  background: #ffffff;\n}\n\n.home-page__body {\n  flex: 1;\n  overflow: auto;\n  padding: 16px;\n}\n\n@media (min-width: 768px) {\n  .home-page__body {\n    /* Stitch: p-6 on content area */\n    padding: 24px;\n  }\n}\n\n.home-page__finder {\n  display: flex;\n  margin-bottom: 16px;\n}\n\n.home-doctor-finder {\n  width: min(320px, 100%);\n  margin-inline-start: auto;\n}\n\n.home-doctor-finder.ant-select .ant-select-selector {\n  height: 36px !important;\n  border-radius: 8px !important;\n  border-color: #e2e8f0 !important;\n  background: #f8fafc !important;\n  align-items: center;\n}\n\n.home-page__columns {\n  --home-columns: 1;\n  display: grid;\n  grid-template-columns: repeat(var(--home-columns), minmax(0, 1fr));\n  gap: 24px;\n  align-items: start;\n  width: 100%;\n  max-width: calc(var(--home-columns) * 480px + (var(--home-columns) - 1) * 24px);\n}\n\n.home-page__column {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n  max-width: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.home-queue {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n  max-width: 100%;\n  width: 100%;\n}\n\n.home-queue__loader {\n  min-width: 0;\n  max-width: 100%;\n  width: 100%;\n}\n\n.home-doctor-head__name {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.25;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.home-doctor-head__specialty {\n  margin: 2px 0 0;\n  font-size: 13px;\n  font-weight: 400;\n  color: #64748B;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.home-queue-search.ant-input-affix-wrapper {\n  width: 100% !important;\n  height: 36px !important;\n  border-radius: 8px !important;\n  background: #F8FAFC !important;\n  border-color: #E2E8F0 !important;\n}\n\n.home-queue-search.ant-input-affix-wrapper-focused {\n  border-color: #0EA5E9 !important;\n  background: #ffffff !important;\n  box-shadow: 0 0 0 1px #0EA5E9 !important;\n}\n\n.home-queue-search .ant-input {\n  background: transparent !important;\n  font-size: 13px !important;\n}\n\n.home-queue-empty {\n  padding: 20px 16px;\n  border-radius: 8px;\n  border: 1px dashed #CBD5E1;\n  background: #F8FAFC;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n  color: #94A3B8;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.home-queue-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.home-queue-list > * {\n  min-width: 0;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
